var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11.25H8.75V8.25H11.75V6.75H8.75V3.75H7.25V6.75H4.25V8.25H7.25V11.25ZM8 15C6.9625 15 5.9875 14.8031 5.075 14.4094C4.1625 14.0156 3.36875 13.4812 2.69375 12.8062C2.01875 12.1312 1.48437 11.3375 1.09062 10.425C0.696875 9.5125 0.5 8.5375 0.5 7.5C0.5 6.4625 0.696875 5.4875 1.09062 4.575C1.48437 3.6625 2.01875 2.86875 2.69375 2.19375C3.36875 1.51875 4.1625 0.984375 5.075 0.590625C5.9875 0.196875 6.9625 0 8 0C9.0375 0 10.0125 0.196875 10.925 0.590625C11.8375 0.984375 12.6312 1.51875 13.3062 2.19375C13.9812 2.86875 14.5156 3.6625 14.9094 4.575C15.3031 5.4875 15.5 6.4625 15.5 7.5C15.5 8.5375 15.3031 9.5125 14.9094 10.425C14.5156 11.3375 13.9812 12.1312 13.3062 12.8062C12.6312 13.4812 11.8375 14.0156 10.925 14.4094C10.0125 14.8031 9.0375 15 8 15Z",
    fill: "#027BFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.d0029661c70eb47d3810f77ce3b8a10f.svg";
export { ForwardRef as ReactComponent };